// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1sO_b","label":"Radio_label__1lr8f","checkMark":"Radio_checkMark__MXIJm","disabled":"Radio_disabled__3IKjy"};